import { ConsumptionRateConfig, Meter, UnitRate } from "../../../types/salesDocuments.types";
import { useMeterContext } from "../meterContext";

export const ConsumptionRateField: React.FC<{
  field: ConsumptionRateConfig;
  meter: Meter;
}> = ({ field, meter }) => {
  const ctx = useMeterContext();

  if (field.hasRate) {
    const rateValue = ctx[field.props as keyof typeof ctx] as UnitRate;
    return (
      <div className="mb-3">
        <label>{field.label}</label>
        <div
          className={`input-group mb-1${ctx.lockedFields.has(field.props) ? " read-only-field" : ""}`}
        >
          <span className="input-group-text">Rate</span>
          <input
            type="number"
            min="0"
            step="0.00001"
            className="form-control"
            id={`meter-${meter.id.toString()}-${field.id}-rate`}
            value={parseFloat(rateValue.rate)}
            onChange={(e) => {
              (ctx[field.setter as keyof typeof ctx] as (v: UnitRate) => void)({
                ...rateValue,
                rate: e.target.value,
              });
            }}
            required={rateValue.consumption !== ""}
          />
        </div>
        <div className="input-group">
          <span className="input-group-text">Consumption</span>
          <input
            type="number"
            min="0"
            step="0.00001"
            className="form-control"
            id={`meter-${meter.id.toString()}-${field.id}-consumption`}
            value={parseFloat(rateValue.consumption)}
            onChange={(e) => {
              (ctx[field.setter as keyof typeof ctx] as (v: UnitRate) => void)({
                ...rateValue,
                consumption: e.target.value,
              });
            }}
            required={rateValue.rate !== ""}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="mb-3">
      <label>{field.label}</label>
      <input
        type="number"
        min="0"
        step="0.00001"
        className="form-control"
        id={`meter-${meter.id.toString()}-${field.id}`}
        value={ctx[field.props as keyof typeof ctx] as string}
        onChange={(e) => {
          (ctx[field.setter as keyof typeof ctx] as (v: string) => void)(e.target.value);
        }}
      />
    </div>
  );
};
